import styled from 'styled-components'
import { Col } from 'react-styled-flexboxgrid-tmp'
// import { BREAK_POINT_MD } from '@CSSVars/variables'
import { TEXT_GREY } from '@CSSVars/colors'

export const _NoFavorite = styled.div`
  width: 100%;
  padding: 1rem;
  background-color: white;
  svg {
    path {
      fill: ${TEXT_GREY};
    }
    .st6 {
      stroke: ${TEXT_GREY};
    }
  }

  h2 {
    font-size: 28px;
    color: ${TEXT_GREY};
    text-align: center;
  }

  h3, p {
    text-align: center;
  }

  h3 {
    font-size: 20px;
    font-weight: 400;
    margin: 10px 0;
    color: ${TEXT_GREY};
  }

  p {
    color: ${TEXT_GREY};
  }
`

export const _ContentCol = styled(Col)`
  padding: 2rem 0;
  display: flex;
  flex-direction: column;
  align-items: center;

`

export const _IconContainer = styled.div`
  height: 60px;
`
